export const prepareSiteRedirection = (language: string, url: string): string =>
    url.startsWith(`/${language}`) ? `${url}/` : `/${language}${url}/`;
